export const INITIAL_PAGINATION = { skip: 0, take: 10 };
